const myemailReportsNamespace = '/email_reports';

const myemailReportListViewRelative = '/assigned';

const myemailReportListViewRoute = `${myemailReportsNamespace}${myemailReportListViewRelative}`;

export const myemailReportsNamespaces = {
    myemailReportsNamespace,
};

export const myemailReportsRelativeRoutes = {
    myemailReportListViewRelative,
};

export const myemailReportsAbsoluteRoutes = {
    myemailReportListViewRoute,
};
